import { render, staticRenderFns } from "./MediaRightAlignBorder.vue?vue&type=template&id=3567f066&"
import script from "./MediaRightAlignBorder.vue?vue&type=script&lang=js&"
export * from "./MediaRightAlignBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports